import React from "react";
import { AvField } from "availity-reactstrap-validation";

const InputGroupWrapper = ({ children }) => {
  const childrenArray = React.Children.toArray(children);

  const inputElement = childrenArray.find((child) => child?.type === AvField);
  const iconElement = childrenArray.find((child) => child !== inputElement);

  return (
    <div style={{ position: "relative" }}>
      {inputElement}
      {iconElement && <span className="input-group-icon">{iconElement}</span>}
    </div>
  );
};

export default InputGroupWrapper;
